import {Component,ChangeDetectionStrategy, ViewEncapsulation,OnInit,Input, ChangeDetectorRef} from '@angular/core';
import { Router } from '@angular/router';
import { NavMenu } from '@app/shared/types/nav-menu.interface';
import { navConfiguration } from '@app/configs/nav.config';
import { NavMenuColor } from '@app/shared/types/app-config.interface';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { OrderService } from '@app/shared/services/order.service';
import { JssService } from '@app/shared/services/jss.service';


@Component({
    selector: 'side-nav',
    templateUrl: './side-nav.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.side-nav]': 'true',
        '[class.nav-menu-collapse]': 'collapse',
        '[class.nav-menu-quick-expand]': 'quickExpand',
        '[class.nav-menu-light]': "color === 'light'",
        '[class.nav-menu-dark]': "color === 'dark'",
    },
    animations: [
        trigger('slideInOut', [
            state(
                'visible',
                style({
                    height: '*',
                    opacity: 1,
                })
            ),
            state(
                'hidden',
                style({
                    height: '0',
                    opacity: 0,
                })
            ),
            transition('visible <=> hidden', animate('300ms ease-in-out')),
        ]),
    ],
})
export class SideNavComponent implements OnInit {
    isSubMenuOpen: boolean;
    orderList: any[] = [];
    filteredOrderList: any[] = [];
    previousPendingCount: number;
    previousConfirmedCount: number;
    pendingCount: number = 0;
    confirmedCount: number = 0;
    confirmOrderId:any[]=[];
    constructor(private router: Router, private cdr: ChangeDetectorRef,
        private orderService: OrderService, private jss: JssService) { }
    menu: NavMenu[] = [];
    @Input() collapse: boolean;
    @Input() quickExpand: boolean;
    @Input() color: NavMenuColor = 'light';

    ngOnInit(): void {
        this.menu = navConfiguration;


        // this piece of code is for checking login user 
          this.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');
  console.log(this.currentUser);

  this.isAdmin = this.currentUser.position === 'Admin';

  this.isSales =
    this.currentUser.position === 'Sales' ||
    this.currentUser.email === 'sales-4@srg-amani.com';

  this.isProduction =
    this.currentUser.position === 'Production' ||
    this.currentUser.position === 'ProductionDPr' ||
    this.currentUser.email === 'qa@srg-amani.com';

    this.isDispatch =
    this.currentUser.position === 'Dispatch' ||
    this.currentUser.email === 'lexipackghanaltd@gmail.com';

      this.isStore =
    this.currentUser.position === 'Store' ||
    this.currentUser.email === 'warehouse@lexipack.net';
        // 

        this.getAllOrder(); // Initial call
        this. getConfirmedOrders();
        setInterval(() => {
            this.getAllOrder();
            this. getConfirmedOrders();
        }, 10000); // Refresh every 10 seconds


        // this to keep submenus open
        if (this.isSales) {
  this.submenus['sale'] = true;
}

 if (this.isProduction) {
  this.submenus['admin || '] = true;
}

if (this.isStore) {
  this.submenus['store'] = true;
}
// 
    }



    getAllOrder() {
        this.orderService.getOrderCount().subscribe(
            (res: any) => {
                // const pendingOrders = res.filter(order => order.status === 'Pending');
                //const confirmedOrders = res.filter(order => order.status === 'Confirmed');

                const newPendingCount = res.pendingCount;
                this.confirmOrderId = res.confirmOrderId;
               // const newConfirmedCount = confirmedOrders.length;

                let messageParts: string[] = [];

                // Compare and build notification message
                if (newPendingCount > this.previousPendingCount) {
                    messageParts.push(`🔔 <strong>${newPendingCount - this.previousPendingCount}</strong> new <strong>Pending</strong> orders`);
                }

                // if (newConfirmedCount > this.previousConfirmedCount) {
                //     messageParts.push(`✅ <strong>${newConfirmedCount - this.previousConfirmedCount}</strong> new <strong>Confirmed</strong> orders`);
                // }

                // Show message if there's any new order
                // if (messageParts.length > 0) {
                //   this.notificationMessage = messageParts.join(' & ') + ' received!';
                //   setTimeout(() => {
                //     this.notificationMessage = '';
                //   }, 1000);
                // }

                // Update counts
                this.pendingCount = newPendingCount;
                // this.confirmedCount = newConfirmedCount;
                this.previousPendingCount = newPendingCount;
                // this.previousConfirmedCount = newConfirmedCount;

                this.cdr.detectChanges();
            },
            (err: any) => {
                console.error('Error fetching orders:', err);
            }
        );
    }



    getConfirmedOrders() {
        // Fetch JSS data first
        this.jss.getJssNotificationCount().subscribe(
            (jssList: any[]) => {
                const jssCreatedIds = new Set( jssList.map(jss => jss.id) );
                this.orderList = this.confirmOrderId.filter(order => !jssCreatedIds.has(order._id));
                this.filteredOrderList = [...this.orderList];
                const newConfirmedCount = this.filteredOrderList.length;
                let messageParts: string[] = [];
                if (newConfirmedCount > this.previousConfirmedCount) {
                    messageParts.push(`✅ <strong>${newConfirmedCount - this.previousConfirmedCount}</strong> new <strong>Confirmed</strong> orders`);
                }
                this.confirmedCount = newConfirmedCount;
                this.previousConfirmedCount = newConfirmedCount;
                this.cdr.detectChanges(); // Trigger change detection

            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    submenus: { [key: string]: boolean } = {
        user: false,
        admin: false,
    };

    toggleSubMenu(submenu: string, event: Event) {
        this.submenus = {
            ...this.submenus,
            [submenu]: !this.submenus[submenu],
        };

        // Close other submenus
        Object.keys(this.submenus).forEach((key) => {
            if (key !== submenu) {
                this.submenus[key] = false;
            }
        });

        // Prevent the default action of the event
        event.preventDefault();
    }


// 
    currentUser: any;
isAdmin = false;
isSales = false;
isProduction = false;
isDispatch = false;
isStore = false;
// 
}
